import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, Renderer2, inject } from '@angular/core';

type StadiaResource = {
  type: 'style' | 'script' | 'json';
  href: string;
};

@Injectable({ providedIn: 'root' })
export class StadiaMapsLoaderService {
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private prefetchCalled = false;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private loadingPromise: Promise<void[]>;

  private resources: StadiaResource[] = [
    { type: 'style', href: 'https://unpkg.com/maplibre-gl@^5.3.0/dist/maplibre-gl.css' },
    { type: 'json', href: 'https://cdn.pedix.app/MWfL7v9QDlts7y2E1jUw/osm_bright.json' },
  ];

  prefetchResources() {
    if (this.prefetchCalled || !isPlatformBrowser(this.platformId)) {
      return;
    }
    this.resources.forEach(resource => {
      const link: HTMLLinkElement = this.document.createElement('link');

      link.rel = 'prefetch';
      link.as = resource.type === 'json' ? 'fetch' : resource.type;
      link.href = resource.href;

      this.document.head.appendChild(link);
    });
    this.prefetchCalled = true;
  }

  loadResources(renderer: Renderer2) {
    if (!this.loadingPromise) {
      const promises = this.resources
        .filter(resource => resource.type === 'script' || resource.type === 'style')
        .map(resource => {
          return new Promise<void>((resolve, reject) => {
            let element: HTMLLinkElement | HTMLScriptElement;

            if (resource.type === 'script') {
              element = <HTMLScriptElement>this.document.createElement('script');

              element.src = resource.href;
              element.async = false;
              element.defer = true;
            } else {
              element = <HTMLLinkElement>this.document.createElement('link');

              element.href = resource.href;
              element.rel = 'stylesheet';
            }

            element.onload = () => {
              resolve();
            };
            element.onerror = () => {
              console.log('onerror');

              reject();
            };

            renderer.appendChild(this.document.head, element);
          });
        });

      this.loadingPromise = Promise.all(promises);
    }

    return this.loadingPromise;
  }
}
